import {useSelector} from 'react-redux';
import SearchFilterTable from '../../microComponents/tablePages/filter/SearchFilterTable';
import UseSetParams from '../../microComponents/tablePages/filter/UseSetParams';
import CreateEditUser from "./CreateEditUser";
import {activatedJson} from "../../helper/jsons/activatedJson";
import SelectFilterTable from "../../microComponents/tablePages/filter/SelectFilterTable";
import ConfirmSwitch from "./ConfirmSwitch";
import {useState} from "react";
import {getFilterBranch} from "../../microComponents/tablePages/getFilterBranch";
// import SelectFilterTable from '../../microComponents/tablePages/filter/SelectFilterTable';

const UserManagementColumn = () => {
    const filter = useSelector((state) => state.TableRedux.filter);
    const [getColumnSearchProps] = SearchFilterTable();
    const [getColumnSelectProps] = SelectFilterTable();
    const [branchList, setBranchList] = useState([]);
    const [branchLoading, setBranchLoading] = useState(false);

    const [handleSetParams] = UseSetParams();
    const getDetailList = () => {

        getFilterBranch((e) => {
            setBranchList([{label: 'همه', value: 0}, ...e])
        }, setBranchLoading)
    }


    const funcHandleSetParams = (newFilter) => {
        handleSetParams(newFilter);
    };

    const columns = [

        {
            title: 'ردیف',
            className: "hidden lg:table-cell",
            dataIndex: 'row',
            key: 'row',
            render: (text, row, index) => {
                return index + 1;
            },
        }, {
            title: ' نام',
            dataIndex: 'firstName',
            key: 'firstName', ...getColumnSearchProps(' نام', filter.firstName, (res) => {
                funcHandleSetParams([{key: 'firstName', value: res}]);
            }, 'firstName'),
        }, {
            title: ' نام خانوادگی',
            dataIndex: 'lastName',
            key: 'lastName', ...getColumnSearchProps(' نام خانوادگی', filter.lastName, (res) => {
                funcHandleSetParams([{key: 'lastName', value: res}]);
            }, 'lastName'),
        }, {
            title: ' نام کاربری', className: "hidden sm:table-cell",
            dataIndex: 'userName',
            key: 'userName', ...getColumnSearchProps(' نام کاربری', filter.userName, (res) => {
                funcHandleSetParams([{key: 'userName', value: res}]);
            }, 'userName'),
        },
        {
            title: ' واحد', className: "hidden sm:table-cell",
            dataIndex: 'branch',
            key: 'branch', ...getColumnSelectProps(filter.branch, 'branch', 'واحد', branchList, getDetailList, (res) => {

                funcHandleSetParams([{key: 'branch', value: res}]);
            }, branchLoading),
        },
        {
            title: 'سمت', className: "hidden md:table-cell",
            dataIndex: 'roles',
            key: 'roles',
            render: (items) => {
                return <div className='flex gap-2 flex-wrap'>{items?.map((item, index) => (
                    <>
                        <span key={index}>{item}</span>
                        <span>{items[index + 1] && '-'}</span>
                    </>
                ))}</div>
            }
        },
        {
            title: ' تاریخ ثبت نام', className: "hidden md:table-cell",
            dataIndex: 'created',
            key: 'created',
        },
        {
            title: 'اخرین ورود', className: "hidden 2md:table-cell",
            dataIndex: 'lastLogin',
            key: 'lastLogin',
        },

        {
            title: ' عملیات', fixed: 'right', className: ' cell-fix-left',
            dataIndex: 'isEnabled',
            key: 'isEnabled', ...getColumnSelectProps(filter.isEnabled, 'isEnabled', 'وضعیت', activatedJson, null, (res) => {
                funcHandleSetParams([{key: 'isEnabled', value: res}]);
            }),
            render: (item, row) => {
                return <div className='flex gap-2 items-center'>
                    <CreateEditUser rowData={row}/>

                    <ConfirmSwitch defStatus={row.isEnabled} rowData={row}/>
                </div>
            }
        },


    ];
    return [columns];
};

export default UserManagementColumn;